import {Component, OnInit} from '@angular/core';
import {DeliverySelect} from "../models/deliverySelect";
import {Router} from "@angular/router";
import {ShoppingSharedService} from "../service/shopping-shared.service";
import {ShippingType} from "../enums/ShippingType";

@Component({
  selector: 'app-shipping-method',
  templateUrl: './shipping-method.component.html',
  styleUrls: ['./shipping-method.component.scss', './shipping-method-media.component.scss']
})
export class ShippingMethodComponent implements OnInit {

  formData: any = null;
  products: any[] = [];
  totalSumAmd!: number;
  totalSumUsd!: number;

  selectedDeliveryMethod: ShippingType = ShippingType.STANDARD;

  deliverySelectStandard!: DeliverySelect;
  deliverySelectExpress!: DeliverySelect;
  deliverySelectPickup!: DeliverySelect;

  deliveryAddress = '';

  constructor(
    private router: Router,
    private shoppingSharedService: ShoppingSharedService
  ) {
  }

  ngOnInit() {
    const navData = history.state || this.router.getCurrentNavigation()?.extras.state;
    if (navData && (navData['shopData'] || navData['totalSumAmd'] || navData['totalSumUsd'])) {
      this.products = navData['shopData'] || [];
      this.totalSumAmd = navData['totalSumAmd'];
      this.totalSumUsd = navData['totalSumUsd'];
      this.shoppingSharedService.products = this.products;
      this.shoppingSharedService.totalSumAmd = this.totalSumAmd;
      this.shoppingSharedService.totalSumUsd = this.totalSumUsd;
    } else {
      this.products = this.shoppingSharedService.products || [];
      this.totalSumAmd = this.shoppingSharedService.totalSumAmd;
      this.totalSumUsd = this.shoppingSharedService.totalSumUsd;
    }

    this.formData = this.shoppingSharedService.formData;
    this.selectedDeliveryMethod = this.shoppingSharedService.shippingType || ShippingType.STANDARD;

    if (!this.products || this.products.length === 0) {
      this.router.navigate(['/cart']);
      return;
    }

    if (this.formData) {
      this.deliveryAddress = this.buildAddressString(this.formData);
    }
    this.deliverySelectStandard = new DeliverySelect(
      this.selectedDeliveryMethod == ShippingType.STANDARD,
      'shipping-method.standard',
      'shipping-method.business_days_20',
      'shipping-method.free'
    );

    this.deliverySelectExpress = new DeliverySelect(
      this.selectedDeliveryMethod == ShippingType.EXPRESS,
      'shipping-method.express',
      'shipping-method.business_days_4',
      'shipping-method.pay_to_yandex'
    );

    this.deliverySelectPickup = new DeliverySelect(
      this.selectedDeliveryMethod == ShippingType.PICKUP,
      'shipping-method.pickup',
      '',
      'shipping-method.pickup_free_text'
    );
  }

  selectDeliveryMethod(method: ShippingType) {
    if(this.selectedDeliveryMethod == method) {
      return;
    }
    this.selectedDeliveryMethod = method;
    this.shoppingSharedService.shippingType = method;
    this.deliverySelectStandard.isActive = (method == ShippingType.STANDARD);
    this.deliverySelectExpress.isActive = (method == ShippingType.EXPRESS);
    this.deliverySelectPickup.isActive = (method == ShippingType.PICKUP);
  }

  truncateText(value: string, limit: number): string {
    if (value.length <= limit) {
      return value;
    }
    return value.substring(0, limit) + '...';
  }

  navigateToShippingAddress() {
    this.router.navigate(['/shipping-address'], {
      state: {
        formData: this.formData,
        shopData: this.products,
        totalSumAmd: this.totalSumAmd,
        totalSumUsd: this.totalSumUsd,
      },
    });
  }

  continueToNextStep() {
    this.shoppingSharedService.products = this.products;
    this.shoppingSharedService.totalSumAmd = this.totalSumAmd;
    this.shoppingSharedService.totalSumUsd = this.totalSumUsd;
    this.shoppingSharedService.shippingType = this.selectedDeliveryMethod;

    if (this.selectedDeliveryMethod === ShippingType.PICKUP) {
      this.router.navigate(['product/payment']);
    } else {
      this.navigateToShippingAddress();
    }
  }

  redirect(url: string, extras?: any) {
    this.router.navigateByUrl(url, extras).catch(err => {
      console.error('Navigation error:', err);
    });
  }

  returnToCart() {
    this.router.navigate(['/cart']).catch(err => {
      console.error('Navigation error:', err);
    });
  }

  private buildAddressString(contactForm: any): string {
    const { country, address, apartment, postalCode, city } = contactForm;

    let fullAddress = `${country}, ${city}, ${address}, ${postalCode}, ${apartment}`;

    fullAddress = fullAddress
      .split(', ')
      .filter(part => part && part.trim().length > 0)
      .join(', ');

    return fullAddress;
  }

  protected readonly ShippingType = ShippingType;
}
